"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingStore = exports.defaultMatchSearchFilter = void 0;
const mobx_1 = require("mobx");
const matching_1 = require("@App/api/routes/rightsholder/matching");
const recording_group_details_1 = require("@Entities/matching/recording-group-details");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const uuid_1 = require("uuid");
const dspRecordingOptions = [
    // For the current designs these are static fields without being included in criteria dropdown but may be included in the future -- including for completion
    { id: (0, uuid_1.v4)(), value: 'recordingTitle', label: 'Recording Title', shouldHide: true },
    { id: (0, uuid_1.v4)(), value: 'isrc', label: 'Recording ISRC', shouldHide: true },
    { id: (0, uuid_1.v4)(), value: 'writer', label: 'Writer', shouldHide: false, forceArray: true },
    { id: (0, uuid_1.v4)(), value: 'artist', label: 'Recording Artist', shouldHide: false, forceArray: true },
];
const defaultMatchingCriteria = [
    {
        id: dspRecordingOptions[0].id,
        selectedOption: dspRecordingOptions[0],
        searchTerm: undefined,
        isFixed: true,
        isDisabled: true,
    },
    {
        id: dspRecordingOptions[1].id,
        selectedOption: dspRecordingOptions[1],
        searchTerm: undefined,
        isFixed: true,
        isDisabled: true,
    },
];
exports.defaultMatchSearchFilter = {
    unmatchedValue: null,
    usageSource: null,
};
class MatchingStore {
    static createMatchSearchCriteriaStore() {
        return new search_criteria_store_1.default(defaultMatchingCriteria, dspRecordingOptions, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.some, 4);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_unmatchedSearchResults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_unmatchedSearchResultsPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedUnmatchedRecordingGroups", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "_currentSearchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchingSearchCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_matchingFilterCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.defaultMatchSearchFilter
        });
        Object.defineProperty(this, "_selectedWorkTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectUnmatchedRecordingGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => this._selectedUnmatchedRecordingGroups.push(id)
        });
        Object.defineProperty(this, "deSelectUnmatchedRecordingGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                this._selectedUnmatchedRecordingGroups.splice(this._selectedUnmatchedRecordingGroups.indexOf(id), 1);
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _unmatchedSearchResults: mobx_1.observable,
            _selectedUnmatchedRecordingGroups: mobx_1.observable,
            _selectedWorkTitle: mobx_1.observable,
            resetStore: mobx_1.action,
            selectUnmatchedRecordingGroup: mobx_1.action,
            deSelectUnmatchedRecordingGroup: mobx_1.action,
            setSelectedWorkTitle: mobx_1.action,
            selectedUnmatchedRecordingGroupsLength: mobx_1.computed,
        });
        this.rootStore = rootStore;
        this.resetSearchCriteriaStore();
    }
    get matchingSearchCriteria() {
        return this._matchingSearchCriteria;
    }
    get matchingFilterCriteria() {
        return this._matchingFilterCriteria;
    }
    get unmatchedSearchResults() {
        return this._unmatchedSearchResults;
    }
    get selectedUnmatchedRecordingGroups() {
        return this._selectedUnmatchedRecordingGroups;
    }
    get selectedUnmatchedRecordingGroupsLength() {
        return this._selectedUnmatchedRecordingGroups.length;
    }
    get searchCriteriaStore() {
        return this._currentSearchCriteriaStore;
    }
    get selectedWorkTitle() {
        return this._selectedWorkTitle;
    }
    loadNextUnmatchedSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.loadUnmatchedSearchResults(this._unmatchedSearchResultsPage + 1);
        });
    }
    loadUnmatchedSearchResults(page) {
        return __awaiter(this, void 0, void 0, function* () {
            this._unmatchedSearchResultsPage = page;
            const criteriaToSend = Object.assign({}, this._matchingFilterCriteria);
            // Ignore Zero Value
            if (criteriaToSend.unmatchedValue === '0') {
                delete criteriaToSend.unmatchedValue;
            }
            const response = yield (0, matching_1.getUnmatchedSearchResults)(this.matchingSearchCriteria, criteriaToSend, page);
            (0, mobx_1.runInAction)(() => {
                var _a, _b, _c, _d;
                page === 1
                    ? (this._unmatchedSearchResults = (0, recording_group_details_1.translateLegacyRecordingGroupList)(response.data))
                    : (this._unmatchedSearchResults = {
                        count: (_b = (_a = this._unmatchedSearchResults) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0,
                        recordingGroups: (_d = (_c = this._unmatchedSearchResults) === null || _c === void 0 ? void 0 : _c.recordingGroups.slice().concat((0, recording_group_details_1.translateLegacyRecordingGroupList)(response.data).recordingGroups)) !== null && _d !== void 0 ? _d : [],
                    });
            });
        });
    }
    setMatchingSearchCriteria(matchingSearchCriteria) {
        this._matchingSearchCriteria = matchingSearchCriteria;
    }
    setMatchingFilterCriteria(matchingFilterCriteria) {
        this._matchingFilterCriteria = matchingFilterCriteria;
    }
    setSelectedWorkTitle(selectedWorkTitle) {
        this._selectedWorkTitle = selectedWorkTitle;
    }
    resetStore() {
        this.resetSearchCriteriaStore();
        (0, mobx_1.runInAction)(() => {
            this._unmatchedSearchResults = undefined;
            this._selectedUnmatchedRecordingGroups = [];
        });
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = MatchingStore.createMatchSearchCriteriaStore();
    }
}
exports.MatchingStore = MatchingStore;
